import axios from "axios";
import { getHeaders } from "../../utils/AuthorizationUtil";
import { AUTHORIZE_BASE_URL } from "../../utils/EmpUtil";
import { is500 } from "../../errors/ErrorConstants";
import AuthenticationFailureHandler from "../../utils/AuthenticationFailureHandler";

export default class AuthenticationClient {
  static baseUrl = AUTHORIZE_BASE_URL;

  static status(authenticationRequest) {
    const url = `${this.baseUrl}/authorize`;

    return axios
      .post(url, authenticationRequest, getHeaders())
      .then((response) => {
        return Promise.resolve(response.data);
      })
      .catch((error) => {
        if (!is500(error)) {
          AuthenticationFailureHandler.execute();
        }
        return Promise.reject(error);
      });
  }
}
